// Tracks in-flight uploads so background helpers (build freshness check,
// beforeunload) never reload the app in the middle of a photo upload.
let inFlight = 0;

export function beginUpload() {
  inFlight++;
  if (inFlight === 1) window.addEventListener("beforeunload", warn);
}

export function endUpload() {
  inFlight = Math.max(0, inFlight - 1);
  if (inFlight === 0) window.removeEventListener("beforeunload", warn);
}

export function isUploadInFlight() {
  return inFlight > 0;
}

function warn(e: BeforeUnloadEvent) {
  e.preventDefault();
  e.returnValue = "";
}
